<div #deliveryAddressEl>
  <fieldset *ngIf="settingsContactForm$ | async as contactFormSettings">
    <ng-container
      [ngSwitch]="contactFormSettings.fields_billing_address.length"
    >
      <legend *ngSwitchCase="0" i18n="@@headline.address">Anschrift</legend>
      <legend *ngSwitchDefault i18n="@@headline.address.delivery"
        >Lieferanschrift
      </legend>
    </ng-container>

    <orderform-inputs-generator
      #deliveryAddressInput
      (dataChanges)="deliveryAddressData$.next($event)"
      [data]="filledShippingAddress$ | async"
      [fields]="contactFormSettings.fields_shipping_address"
      [attr.data-e2e]="'form:address:shipping'"
    ></orderform-inputs-generator>
  </fieldset>
</div>

<div #billingAddressEl>
  <ng-container *ngIf="settingsContactForm$ | async as contactFormSettings">
    <fieldset *ngIf="contactFormSettings.fields_billing_address.length">
      <legend i18n="@@headline.address.billing">Rechnungsanschrift</legend>

      <div>
        <input
          [ngModel]="isBillingAddressSameAsDeliveryOpen$ | async"
          type="checkbox"
          #checkbox
          id="sameAsDelivery"
          (change)="manualBillingAddressIsSame$.next(checkbox.checked)"
        />
        <label class="input-checkbox" for="sameAsDelivery">
          <ng-container i18n="@@address.enter.billingAddressSameAsDelivery">
            Gleich wie meine Adresse
          </ng-container>
        </label>
      </div>

      <ng-container
        *ngIf="(isBillingAddressSameAsDeliveryOpen$ | async) === false"
      >
        <orderform-inputs-generator
          #billingAddressInput
          (dataChanges)="billingAddressData$.next($event)"
          [data]="filledBillingAddress$ | async"
          [fields]="contactFormSettings.fields_billing_address"
          [attr.data-e2e]="'form:address:billing'"
        ></orderform-inputs-generator>
      </ng-container>
    </fieldset>
  </ng-container>
</div>
